import { CListGroup } from './CListGroup.js';
import { CListGroupItem } from './CListGroupItem.js';

const CListGroupPlugin = {
    install: (app) => {
        app.component(CListGroup.name, CListGroup);
        app.component(CListGroupItem.name, CListGroupItem);
    },
};

export { CListGroup, CListGroupItem, CListGroupPlugin };
//# sourceMappingURL=index.js.map
